export const StorageContextType = {
	order: 0,
	order_deviation: 1,
	task: 10,
};
